import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Divider } from "@material-ui/core";
import { ModalProgressBar } from "../../../../_metronic/_partials/controls";
import { Link } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
import * as proposalService from "../../../../services/service/proposalService";
import * as alert from '../../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../../redux/confirmModalRedux';
import * as helper from '../../../../helpers/helper';
import ConsolidateChargeValidator from '../../../../helpers/validators/ConsolidateChargesValidator';
import { useFormik } from "formik";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import constants from '../../../../constants/constants';

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const ProposalEstimatorPage = (props) => {
    const { isReadOnly, proposalIdParam, showAlert, showConfirmModal, hideConfirmModal, auth } = props;
    const [loading, setLoading] = useState(false);
    const [showFilePond, setShowFilePond] = useState(false);
    const [uploadedFile, setUploadedFile] = useState([]);
    const [isEditingCharges, setIsEditingCharges] = useState(false);
    const [consolidate, setConsolidate] = useState({
        id: 0,
        name: '',
        cost: ''
    });

    const [proposalEstimator, setProposalEstimator] = useState({
        estimatorFilePath: null,
        proposalEstimatedConsolidatedCharges: [],
        estimatedTotalCost: '',
        uploadedFile: null,
        budgetPercentage: ''
    });

    useEffect(() => {
        proposalService.GetProposalEstimator(proposalIdParam).then(res => {
            setProposalEstimator(res);
            setShowFilePond(res.estimatorFilePath === null);
        }).catch(ex => showAlert({ message: ex.message, variant: 'error' }));
    }, []);

    const formik = useFormik({
        initialValues: consolidate,
        enableReinitialize: true,
        validationSchema: ConsolidateChargeValidator,
        onSubmit: (values, { setStatus, setSubmitting, resetForm }) => {
            if (isEditingCharges) {
                let tempArr = [...proposalEstimator.proposalEstimatedConsolidatedCharges];
                tempArr[values.index] = values;
                setProposalEstimator({ ...proposalEstimator, proposalEstimatedConsolidatedCharges: tempArr });
                setIsEditingCharges(false);
                setConsolidate({
                    id: 0,
                    name: '',
                    cost: ''
                })
            } else {
                setProposalEstimator({ ...proposalEstimator, proposalEstimatedConsolidatedCharges: [...proposalEstimator.proposalEstimatedConsolidatedCharges, values] });
            }
            resetForm();
        }
    });

    const saveProposalEstimator = () => {
        setLoading(true);

        proposalService.SaveProposalEstimator(helper.convertJsonToFormData({
            ...proposalEstimator,
            proposalEstimatedConsolidatedChargesString: JSON.stringify(proposalEstimator.proposalEstimatedConsolidatedCharges),
            proposalEstimatedConsolidatedCharges: null,
            uploadedFile: uploadedFile.length === 0 ? null : uploadedFile[0].file
        })).then(res => {
            if (res.filePath) {
                setShowFilePond(false);
                setProposalEstimator({ ...proposalEstimator, estimatorFilePath: res.filePath })
            }
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => setLoading(false))
    }

    const removeEstimator = () => {
        setLoading(true);

        proposalService.RemoveProposalEstimatorFile(proposalIdParam).then(res => {
            showAlert({ message: res.message, variant: 'success' });
            setProposalEstimator({ ...proposalEstimator, estimatorFilePath: null })
            setShowFilePond(true);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => {
            setLoading(false);
            hideConfirmModal();
        })
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                download: false,
                print: false,
                setCellProps: () => ({
                    'data-aes-field': 'actions',
                    'data-aes-label': 'Actions'
                }),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div className="aes-admin-listing-actions">
                            <button
                                disabled={isReadOnly}
                                onClick={() => {
                                    setIsEditingCharges(true);
                                    setConsolidate({
                                        id: proposalEstimator.proposalEstimatedConsolidatedCharges[dataIndex].id,
                                        name: proposalEstimator.proposalEstimatedConsolidatedCharges[dataIndex].name,
                                        cost: proposalEstimator.proposalEstimatedConsolidatedCharges[dataIndex].cost,
                                        index: dataIndex
                                    })
                                }}
                                className="btn btn-sm btn-info font-weight-bold font-size-sm mr-3"
                            >
                                Edit
                            </button>
                            <button
                                disabled={isReadOnly}
                                className={`btn btn-danger btn-sm font-weight-bold font-size-sm mr-3`}
                                onClick={() => {
                                    let tempArr = [...proposalEstimator.proposalEstimatedConsolidatedCharges]
                                    tempArr.splice(dataIndex, 1);
                                    setProposalEstimator({ ...proposalEstimator, proposalEstimatedConsolidatedCharges: tempArr });
                                }}
                            >
                                Remove
                            </button>
                        </div>
                    );
                }
            },

        },
        {
            name: "name",
            label: "Consolidate Name",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'charge-name',
                    'data-aes-label': 'Consolidate Name'
                }),
            }
        },
        {
            name: "cost",
            label: "Cost",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'cost',
                    'data-aes-label': 'Cost'
                }),
                customBodyRenderLite: (dataIndex) => <p>${proposalEstimator.proposalEstimatedConsolidatedCharges[dataIndex].cost}</p>
            }
        }
    ];

    return (
        <div className="card card-custom" >
            {loading && <ModalProgressBar />}
            <div className="card-header py-3">
                <div className="card-title align-items-start flex-column">
                    <h3 className="card-label font-weight-bolder text-dark">
                        Proposal Estimator
                    </h3>
                    <span className="text-muted font-weight-bold fz-xs mt-1">
                        View & Edit Proposal Estimator
                    </span>
                </div>
                {
                    !isReadOnly &&
                    <div className="card-toolbar">
                        <button
                            onClick={saveProposalEstimator}
                            disabled={loading}
                            className="btn btn-success mr-2"
                        >
                            Save Changes
                        </button>
                        <Link
                            to="/services/proposals"
                            className="btn btn-secondary"
                        >
                            Cancel
                        </Link>
                    </div>
                }
            </div>
            <div className="form">
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-9 col-xl-6 d-flex w-100 justify-content-between">
                            <h5 className="mb-6 fz-md fw-700 c-primary">Estimator File</h5>
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-xl-12 col-lg-12">
                            {
                                showFilePond ?
                                    <FilePond
                                        acceptedFileTypes={".xlsx"}
                                        labelIdle='Drag & Drop Proposal Estimator or <span class="filepond--label-action">Browse</span>'
                                        onupdatefiles={setUploadedFile}
                                    /> :
                                    <>
                                        <a className="btn btn-primary" target="_blank" href={constants.API_URL + "Attachments" + proposalEstimator.estimatorFilePath}>View Estimator</a>
                                        &nbsp;
                                        {
                                            !isReadOnly &&
                                            <button className="btn btn-danger" onClick={() => showConfirmModal({
                                                title: "Remove Estimator",
                                                text: "Are you sure you want to remove the estimator?",
                                                rightBtnText: "Confirm",
                                                btnAction: () => removeEstimator()
                                            })}>Remove Estimator</button>
                                        }
                                    </>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-9 col-xl-6 d-flex w-100 justify-content-between">
                            <h5 className="mb-6 fz-md fw-700 c-primary">Consolidated Charges</h5>
                        </div>
                    </div>
                    <form
                        onSubmit={formik.handleSubmit}
                    >
                        {
                            !isReadOnly &&
                            <div className="form-group row">
                                <div className="col-xl-9 col-lg-9">
                                    <input
                                        placeholder="Consolidate Name"
                                        className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik, "name")}`}
                                        {...formik.getFieldProps("name")}
                                    />
                                    {formik.touched.name && formik.errors.name ? (
                                        <div className="invalid-feedback">{formik.errors.name}</div>
                                    ) : null}
                                </div>
                                <div className="col-xl-2 col-lg-2">
                                    <input
                                        placeholder="Cost"
                                        className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik, "cost")}`}
                                        {...formik.getFieldProps("cost")}
                                    />
                                    {formik.touched.cost && formik.errors.cost ? (
                                        <div className="invalid-feedback">{formik.errors.cost}</div>
                                    ) : null}
                                </div>
                                <div className="col-xl-1 col-lg-1">
                                    <button className="btn btn-primary">{isEditingCharges ? "Update" : "Add"}</button>
                                </div>
                            </div>
                        }
                    </form>
                    <div className="containter aes-admin-listing-page aes-admin-listing-page--proposal-consolidated-charges">
                        <div className="aes-admin-listing">
                        <MUIDataTable
                            className="aes-admin-listing-surface"
                            data={proposalEstimator.proposalEstimatedConsolidatedCharges}
                            columns={columns}
                            options={{
                                responsive: 'standard',
                                selectableRows: 'none',
                                downloadOptions: false,
                                setTableProps: () => ({
                                    className: 'aes-admin-listing-table',
                                }),
                            }}
                        />
                        </div>
                    </div>
                    <div className="row mt-12">
                        <div className="col-lg-10 col-xl-10 d-flex w-100 justify-content-between">
                            <h6 className="mb-6 fz-md fw-500 c-primary">Total</h6>
                        </div>
                        <div className="col-lg-2 col-xl-2 d-flex w-100 justify-content-end">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Dollar.svg")} /> </span>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    readOnly={isReadOnly}
                                    value={proposalEstimator.estimatedTotalCost}
                                    onChange={e => setProposalEstimator({ ...proposalEstimator, estimatedTotalCost: e.target.value })}
                                    placeholder="0.00"
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="cost"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-lg-10 col-xl-10 d-flex w-100 justify-content-between">
                            <h6 className="mb-6 fz-md fw-500 c-primary">Budget Percentage</h6>
                        </div>
                        <div className="col-lg-2 col-xl-2 d-flex w-100 justify-content-end">
                            <div className="input-group input-group-lg input-group-solid">
                                <input
                                    type="text"
                                    readOnly={isReadOnly}
                                    value={proposalEstimator.budgetPercentage}
                                    onChange={e => setProposalEstimator({ ...proposalEstimator, budgetPercentage: e.target.value })}
                                    placeholder="0.00"
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="budgetPercentage"
                                />
                                <div className="input-group-append">
                                    <span className="input-group-text">
                                        <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Sale1.svg")} /> </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <Divider />
                    <div className="row mt-5">
                        <div className="col-lg-9 col-xl-9 d-flex w-100 justify-content-between">
                            <h5 className="mb-6 fz-md fw-700 c-primary">Budget Total</h5>
                        </div>
                        <div className="col-lg-3 col-xl-3 d-flex w-100 justify-content-end">
                            <input
                                type="text"
                                readOnly={true}
                                className={`form-control form-control-lg form-control-solid`}
                                value={(proposalEstimator.estimatedTotalCost - (proposalEstimator.budgetPercentage * proposalEstimator.estimatedTotalCost) / 100).toFixed(2)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, { ...alert.actions, ...confirmModal.actions })(ProposalEstimatorPage);
